<template>
    <div class="contact-container">
        <div class="contact-item active">
            <img class="icon-img" src="../../assets/help.png" alt="">
            <div class="contact-way">助理</div>
            <!-- 弹出层 -->
            <div class="pop">
                <img :src="companyInfo.service_qrcode" alt="助理">
                <div class="pop-title">扫码添加</div>
            </div>
        </div>
        <div class="contact-item">
            <img class="icon-img" src="../../assets/wechat.png" alt="">
            <div class="contact-way">公众号</div>
            <div class="pop">
                <img :src="companyInfo.mobile_qrcode" alt="公众号">
                <div class="pop-title">扫码添加公众号</div>
            </div>
        </div>
        <div class="contact-item">
            <img class="icon-img" src="../../assets/chat.png" alt="">
            <div class="contact-way">群聊</div>
            <div class="pop">
                <img :src="companyInfo.group_qrcode" alt="群聊">
                <div class="pop-title">扫码添加</div>
            </div>
        </div>
    </div>
</template>

<script>
    import { getCompanyInfo } from "@/api/home"
    export default {
        data() {
            return {
                contactList:[{
                    id:1,
                    img:require('../../assets/help.png'),
                    label:'助理'
                },{
                    id:2,
                    img:require('../../assets/wechat.png'),
                    label:'公众号'
                },{
                    id:3,
                    img:require('../../assets/chat.png'),
                    label:'聊天'
                }],
                companyInfo:{}
            }
        },
        created() {
            this.getCompanyInfo()
        },
        methods:{
            getCompanyInfo() {
                getCompanyInfo().then(res=>{
                    if(res.data) {
                        this.companyInfo = res.data
                    }
                })
            }
        }
    }
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
    .contact-container {
        width: 100%;
        height: 100%;
    }
    .contact-item {
        padding-top: 16px;
        box-sizing: border-box;
        text-align: center;
        position: relative;
        &:hover {
            .pop {
                transform: scaleY(1);
            }
        }
    }
    .contact-item .icon-img{
        width: 32px;
        height: 32px;
        filter: grayscale(100%);
    }
    .contact-item.active {
        color: @primary;
    }
    .contact-way {
        height: 20px;
        font-size: 14px;
        font-weight: 600;
        color: @tipwords;
        line-height: 20px;
    }
    .pop {
        position: absolute;
        right: 91px;
        top: 0;
        padding: 10px 15px;
        background: #fff;
        border-radius: 5px;
        transform: scaleY(0);
        transform-origin: right top;
        transition: 0.5s;
        width: 192px;
        height: 199px;
        box-sizing: border-box;
        border-radius: 20px;
    }
    .pop-title {
        font-size: 14px;
        font-weight: 600;
        text-align: center;
        margin-top: 10px;
        color: @words;
    }
    .pop::after {
        content: '';
        position: absolute;
        transform: translateX(-50%) rotate(45deg);
        width: 15px;
        height: 15px;
        background: #fff;
        right: -15px;
        top: 37px;
    }
    .pop img {
        width: 135px;
        height: 135px;
        margin-top: 12px;
    }
</style>